import React from "react";
import { useRoles } from "../utils/useAuth";
import { Navigate } from "react-router-dom";

function AdminRoute({ children }) {
  const { isAuthenticated, isAdmin } = useRoles();

  if (!isAuthenticated) return <Navigate to="/" />;
  if (!isAdmin) return <Navigate to="/" />;

  return children;
}

export default AdminRoute;
